<template>
  <div class="main-body">
    <div class="header">收银机订单</div>
    <div class="out">

      <div class="search2">

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "收银机订单.xls"
            style="display: inline-block;">
          <el-button type="success" size="mini">导出</el-button>
        </download-excel>

        <div style="float:right;">


          <el-select v-model="cashierCode" placeholder="请选择收银员" clearable style="margin-right: 10px;">
            <el-option
                v-for="item in cashierList"
                :key="item.cashierCode"
                :label="item.name"
                :value="item.cashierCode">
            </el-option>
          </el-select>
          <el-date-picker style="margin-right: 10px;width:240px;" size="mini"
                          v-model="startEndTime"
                          type="datetimerange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
          v-loading="loading" ref="table"
          :summary-method="getSummaries" show-summary
          border style="width: 100%;">

        <el-table-column prop="serialNumber" label="流水号" width="130" fixed></el-table-column>
        <el-table-column prop="user.name" width="105" label="老人姓名" ></el-table-column>
        <el-table-column prop="user.phone" width="150" label="老人手机号" ></el-table-column>
        <el-table-column prop="cashierName" label="收银员" width="100"></el-table-column>

        <el-table-column prop="" label="商品名称" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" label="单价" width="105">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsPrice}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="105" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="price" :formatter="getPrice" width="105" label="总价" ></el-table-column>
        <el-table-column width="105" label="订单类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderType ==2 ">单独服务</div>
            <div v-if="scope.row.orderType ==3 ">合并服务</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="付款类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.payType == 'wx' ">微信</div>
            <div v-if="scope.row.payType == 'ali' ">支付宝</div>
            <div v-if="scope.row.payType == 'yue' ">余额</div>
            <div v-if="scope.row.payType == 'cash' ">现金</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" width="105" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 10">未付款</span>
            <span v-if="scope.row.status == 14">交易完成</span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="status" width="105" label="删除">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.isDelete == 1">已删除</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="createTime" :formatter="timefilter" width="180" label="下单时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
             <el-button type="text" v-if="scope.row.isDelete!=1" size="small" @click="deleteOrder(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <OrderInfoAdm ref="OrderInfo"  v-show="orderInfoShow"   v-on:closeOrderInfo="closeOrderInfo"    ></OrderInfoAdm>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode,getStaffDTO} from "@/utils/auth";

import QRCode from "qrcodejs2";
import OrderInfoAdm from "./OrderInfo";

export default {
  name: "Role",
  data() {
    return {
      orderInfoShow:false,

      orderPrice:0,

      cashierCode:'',
      cashierList:[],


      OpenQrCode: false,
      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,

      orderBusinessCode: '',

      startEndTime:[],

      showModal:false,
      json_fields: {
        "流水号": {
          field:"serialNumber",
          callback:value=>{
            return value+"-";
          }
        },
        "老人姓名": "user.name",
        "老人手机号": "user.phone",
        "收银员": "cashierName",
        "商品名称": {
          filed:"listOrderGoodsDTO",
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].goodsName+'</div>';
            }
            return str;
          }
        },
        "单价": {
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].goodsPrice+'</div>';
            }
            return str;
          }
        },
        "数量": {
          callback:value=>{
            let arr = value.listOrderGoodsDTO;
            let str = "";
            for(var i=0;i<arr.length;i++){
              str += '<div>'+arr[i].number+'</div>';
            }
            return str;
          }
        },
        "总价": "price",
        "订单类型": {
          field:"orderType",
          callback:value=>{
            let title = "";
            if(value == 2){
              title = "单独服务";
            }
            if(value == 3){
              title = "合并服务";
            }
            return title;
          }
        },
        "付款类型": {
          field:"payType",
          callback:value=>{
            let title = "";
            if(value == 'cash'){
              title = "现金";
            }
            if(value == 'yue'){
              title = "余额";
            }
            if(value == 'wx'){
              title = "微信";
            }
            if(value == 'ali'){
              title = "支付宝";
            }
            return title;
          }
        },
        "订单状态": {
          field:"status",
          callback:value=>{
            let title = "";
            if(value == '10'){
              title = "待付款";
            }
            if(value == '11'){
              title = "待接单";
            }
            if(value == '12'){
              title = "待开始";
            }
            if(value == '13'){
              title = "待结束";
            }
            if(value == '14'){
              title = "待评价";
            }
            if(value == '15'){
              title = "已取消";
            }
            if(value == '16'){
              title = "已评价";
            }
            if(value == '17'){
              title = "已关闭";
            }
            return title;
          }
        },
        "删除": {
          field:"isDelete",
          callback:value=>{
            let title = "";
            if(value == 0){
              title = "";
            }
            if(value == 1){
              title = "已删除";
            }
            return title;
          }
        },
        "下单时间": {
          field:"createTime",
          callback:value=>{
            return timefilters(value);
          }
        },



      },


    }
  },
  components: {
    OrderInfoAdm,
  },
  created() {
    this.init();
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
    startTime(e) {
      console.log(e)
    }
  },
  methods: {
    init() {

      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
      this.startEndTime = [start, end];

      this.getCashierList();
      this.getList();

    },

    getCashierList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Cashier/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          businessCode:getStaffDTO().businessDTO.businessCode,
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.cashierList = response.data.data;
        } else if (response.data.error === 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })
    },



    getPrice(row){
      return parseFloat(row.price).toFixed(2)
    },
    openQr(row) {
      this.OpenQrCode = true;
      if (document.getElementById("qrcode")) {
        document.getElementById("qrcode").innerHTML = "";
      }
      this.$nextTick(function () {
        this.qrcodeInit(row);
      })
    },


    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },


    getList(isSearch) {
      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true

      //if(this.isDelete == ''){this.isDelete = 0;}

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusiness/PageForCashierOrder",
        data:{
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          startTime:this.startEndTime[0],
          endTime:this.startEndTime[1],
          cashierCode:this.cashierCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.orderPrice=response.data.data.allPrice;
          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })
        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },

    //发货
    Shipments(row){
      this.openShipments=true
      this.shipmentsForm.orderBusinessCode=row.orderBusinessCode
    },
    subShipments(){
      this.$refs.shipmentsForm.validate((valid) => {
        if(valid){
          var data={
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
          }
          Object.assign(data,this.shipmentsForm)
          this.$axios({
            method: 'post',
            url: this.$shopUrl + "OrderBusiness/Shipments",
            data:data
          }).then((response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$message({type: 'success', message: '发货成功'});
              this.openShipments=false
              this.getList();
            } else if (response.data.error === 1) {
              this.$message({type: 'warning', message: response.data.message});
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      })
    },

    //生成二维码
    qrcodeInit(row) {
      new QRCode('qrcode', {
        width: 250,
        height: 250,        // 高度
        text: row.orderBusinessCode,   // 二维码内容
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    //订单详情
    orderInfo(row){
      this.$refs.OrderInfo.init(row)
      this.orderInfoShow =!this.orderInfoShow;
    },

    getSummaries(param) {

      //const { columns, data } = param;console.log(data);
      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {

        if (index === 0) {
          sums[index] = '合计';
        }

        if (index == 7) {
          sums[index] = parseFloat(this.orderPrice).toFixed(2);
        }


        // const values = data.map(item => Number(item[column.property]));
        // if (!values.every(value => isNaN(value))) {
        //     sums[index] = values.reduce((prev, curr) => {
        //         const value = Number(curr);
        //         if (!isNaN(value)) {
        //             return prev + curr;
        //         } else {
        //             return prev;
        //         }
        //     }, 0);
        //     sums[index] += ' 元';
        // } else {
        //     sums[index] = 'N/A';
        // }




      });


      return sums;
    },


    async fetchData(){

      //if(this.isDelete == ''){this.isDelete = 0;}

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:1,
        pageSize:99999,
        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],
        //isDelete:this.isDelete-1,
        cashierCode:this.cashierCode,
      }

      const response = await this.$axios.post(this.$shopUrl + "OrderBusiness/PageForCashierOrder",data);
      return response.data.data.pageInfo.list;
    },

    startDownload:function (){
      this.showModal = true;
    },

    finishDownload:function (){
      this.showModal = false;
    },


    deleteOrder(row){
      this.$confirm('是否删除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusiness/DeleteOrderBusiness",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            orderBusinessCode:row.orderBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '删除成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });
    },


  }
}
</script>

<style scoped>

/*table一条合计行滚动条样式*/
.el-table{
  overflow: auto;
}
.el-table .el-table__body-wrapper,
.el-table .el-table__header-wrapper,
.el-table .el-table__footer-wrapper{
  overflow: visible;
}
.el-table::after{
  position:relative !important;
}

</style>
